var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data.assets),function(asset,index){return _c('AssetBar',{key:index,attrs:{"data":asset}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }